<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="100px">
        <el-row>
          <el-col span="8">
            <el-form-item
              prop="name"
              label="任务名称："
              :rules="[{ required: true, message: '请输入任务名称', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.name"
                placeholder="请输入 任务名称"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item
              prop="type"
              label="任务类型："
              :rules="[{ required: true, message: '请选择任务类型', trigger: 'change' }]"
            >
              <el-select v-model="formData.type" placeholder="请选择 任务类型" style="width: 100%">
                <el-option
                  v-for="item in taskTypes"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item
              prop="taskLevel"
              label="优先级："
              :rules="[{ required: true, message: '请输入优先级', trigger: 'change' }]"
            >
              <el-select
                v-model="formData.taskLevel"
                placeholder="请选择 优先级"
                style="width: 100%"
              >
                <el-option
                  v-for="item in priorityDictData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="_dateRange"
              label="任务日期："
              :rules="[{ required: true, message: '请选择任务日期', trigger: 'change' }]"
            >
              <el-date-picker
                v-model="formData._dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="_timePeriod"
              label="时间段："
              :rules="[{ required: true, message: '请选择时间段', trigger: 'change' }]"
            >
              <el-time-picker
                is-range
                v-model="formData._timePeriod"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="HH:mm"
                style="width: 100%"
              >
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item
              prop="dialogue"
              label="话术："
              :rules="[{ required: true, message: '请输入话术', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.dialogue"
                placeholder="请输入 话术"
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="重呼规则：">
              <div class="form-item-connector">
                <span>未接通用户，间隔</span>
                <el-form-item
                  prop="taskInterval"
                  :rules="[
                    { pattern: /^\+?[1-9][0-9]*$/, message: '只能输入正整数', trigger: 'change' },
                  ]"
                >
                  <el-input v-model="formData.taskInterval" maxlength="3"></el-input>
                </el-form-item>
                <span>分，重拨</span>
                <el-form-item
                  prop="repeatTimes"
                  :rules="[
                    { pattern: /^\+?[1-9][0-9]*$/, message: '只能输入正整数', trigger: 'change' },
                  ]"
                >
                  <el-input v-model="formData.repeatTimes" maxlength="3"></el-input>
                </el-form-item>
                <span>次</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item
              prop="_callFile"
              label="呼叫对象："
              :rules="[{ required: true, message: '请导入呼叫对象' }]"
            >
              <el-upload
                :file-list="formData._callFile"
                :http-request="addFile"
                :before-remove="delFile"
                :on-change="fileChanged"
                :multiple="false"
                accept=".xls,.xlsx"
              >
                <el-button type="primary" size="small"> 导入 </el-button>
              </el-upload>
              <el-button type="text" size="small" @click="downloadTemplate"> 下载模板 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" :loading="isSaving" @click="doSave"> 保存 </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/util/auth';
import { getDictApi } from '@/api/call-system/index';
import { addApi } from '@/api/call-system/call-manage/outbound-task';

export default {
  name: 'AddDialog',
  props: ['projectId'],
  data() {
    return {
      isSaving: false, // 是否正在保存
      // 表单数据
      formData: {
        _callFile: [], // 导入的文件列表
        _dateRange: [], // 日期范围
      },
      taskTypes: [], // 任务类型
      priorityDictData: [], // 优先级字典数据
    };
  },
  created() {
    this.formData.projectId = this.projectId;
    getDictApi({
      code: 'callcenter_task_type',
    }).then(({ data }) => {
      this.taskTypes = data;
    });
    getDictApi({
      code: 'callcenter_task_level',
    }).then(({ data }) => {
      this.priorityDictData = data;
    });
  },
  methods: {
    /* 模板下载 */
    downloadTemplate() {
      window.open(
        `/api/v4ward/callcenter/calltask/exportTemplate?${this.website.tokenHeader}=${getToken()}`
      );
    },
    /* 变更上传文件 */
    fileChanged(file, fileList) {
      this.formData._callFile = fileList.slice(-1); // 只保留最后上传的那个
    },
    /* 上传文件 */
    addFile(file) {
      // 这个方法必须存在，否则组件会报错
    },
    /* 删除文件 */
    delFile() {
      this.formData._callFile = [];
    },
    /* 校验文件 */
    async virefyFile() {
      let isFileValid = true;
      // 下面这行代码是为了解决问题：有时候选择文件后又去本地修改了文件，这个时候上传就会报错，这个是浏览器的机制决定的
      await this.fileList[0].raw
        .slice(0, 1)
        .arrayBuffer()
        .then(() => {
          isFileValid = true;
        })
        .catch((err) => {
          isFileValid = false;
        });
      if (!isFileValid) {
        this.formData._callFile = [];
        this.$message.warning('文件有更新，请重新导入文件后再保存');
        return false;
      }
      return true;
    },
    /* 保存 */
    doSave() {
      this.isSaving = true;
      this.$refs.formRef.validate((valid) => {
        if (!this.virefyFile()) {
          this.isSaving = false;
          return;
        }
        if (valid) {
          if (this.formData._dateRange && this.formData._dateRange.length > 0) {
            this.formData.startDate = this.dayjs(this.formData._dateRange[0]).format('YYYY-MM-DD');
            this.formData.endDate = this.dayjs(this.formData._dateRange[1]).format('YYYY-MM-DD');
          } else {
            this.formData.startDate = '';
            this.formData.endDate = '';
            this.formData._dateRange = [];
          }
          if (this.formData._timePeriod && this.formData._timePeriod.length > 0) {
            this.formData.timePeriod =
              this.formData._timePeriod[0] + '-' + this.formData._timePeriod[1];
          } else {
            this.formData.timePeriod = '';
            this.formData._timePeriod = [];
          }
          let params = Object.assign({}, this.formData);
          delete params._callFile;
          delete params._dateRange;
          delete params._timePeriod;
          let fd = new FormData();
          fd.append('callFile', this.formData._callFile[0].raw);
          for (let k in params) {
            fd.append(k, params[k]);
          }
          addApi(fd, {
            showLoading: { text: '处理中...' },
          })
            .then(() => {
              this.$message.success('操作成功!');
              this.$emit('update');
              this.isSaving = false;
            })
            .catch(() => {
              this.isSaving = false;
            });
        } else {
          this.isSaving = false;
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

/* 文字拼接输入框 */
.form-item-connector {
  display: flex;
  align-items: center;
  span {
    white-space: nowrap;
    margin: 0 5px;
  }
}

/* 文字拼接输入框的输入框宽度调小 */
::v-deep .form-item-connector .el-form-item,
::v-deep .form-item-connector .el-input {
  width: 80px !important;
}
</style>
